import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";
import { CheckCircle, Star, Zap, Sparkles, Crown, TrendingUp } from "lucide-react";

const PricingSection = () => {
  const handleScheduleMeeting = () => {
    // Redirect to Calendly for scheduling
    window.open('https://calendly.com/advisorxai/30min', '_blank');
  };

  return (
      <section id="pricing" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-credentra-dark-teal mb-6">
            Performance-Based Pricing
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Pay nothing upfront. Only pay when we successfully recover tax credits for your business.
          </p>
        </div>
        
        <div className="max-w-2xl mx-auto relative">
          {/* Background glow effect removed */}
          
          <div className="pricing-card relative">
            <div className="text-center">
              {/* Features list */}
              <div className="space-y-4 mb-10">
                <div className="flex items-start text-left">
                  <CheckCircle className="h-6 w-6 mr-4 flex-shrink-0 mt-0.5" style={{color: '#00d6cf'}} />
                  <span className="text-lg text-gray-700 font-semibold">Complete FICA tip credit automation</span>
                </div>
                <div className="flex items-start text-left">
                  <CheckCircle className="h-6 w-6 mr-4 flex-shrink-0 mt-0.5" style={{color: '#00d6cf'}} />
                  <span className="text-lg text-gray-700">All integrations (Toast, Square, QuickBooks, etc.)</span>
                </div>
                <div className="flex items-start text-left">
                  <CheckCircle className="h-6 w-6 mr-4 flex-shrink-0 mt-0.5" style={{color: '#00d6cf'}} />
                  <span className="text-lg text-gray-700">IRS-ready Form 8846 generation</span>
                </div>
                <div className="flex items-start text-left">
                  <CheckCircle className="h-6 w-6 mr-4 flex-shrink-0 mt-0.5" style={{color: '#00d6cf'}} />
                  <span className="text-lg text-gray-700">CPA collaboration</span>
                </div>
                <div className="flex items-start text-left">
                  <CheckCircle className="h-6 w-6 mr-4 flex-shrink-0 mt-0.5" style={{color: '#00d6cf'}} />
                  <span className="text-lg text-gray-700">Audit trail and documentation</span>
                </div>
                <div className="flex items-start text-left">
                  <CheckCircle className="h-6 w-6 mr-4 flex-shrink-0 mt-0.5" style={{color: '#00d6cf'}} />
                  <span className="text-lg text-gray-700">Priority support</span>
                </div>
              </div>
              
              {/* CTA Button - New Brand Colors */}
              <Button 
                size="lg" 
                className="text-white text-xl py-6 px-12 w-full mb-6 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
                style={{background: 'linear-gradient(135deg, #00d6cf, #3c778d)', boxShadow: '0 4px 20px rgba(0, 214, 207, 0.3)'}}
                onClick={handleScheduleMeeting}
              >
                <Sparkles className="mr-3 h-6 w-6" />
                Schedule Meeting
                <TrendingUp className="ml-3 h-6 w-6" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;